export const REFINE_TABLE_DATA = 'REFINE_TABLE_DATA'
export const TABLE_ROWS_TO_BE_REFINED = 'TABLE_ROWS_TO_BE_REFINED'
export const REMOVE_TECH_SPECS_COLUMN = 'REMOVE_TECH_SPECS_COLUMN'
export const UPDATE_PRODUCT_COMPARISON_PAGE_DATA = 'UPDATE_PRODUCT_COMPARISON_PAGE_DATA'
export const UPDATE_PRODUCT_DETAILS = 'UPDATE_PRODUCT_DETAILS'
